/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   City Link Constants
 */

// US CITIES
export const ARLINGTON = { name: 'Arlington', url: 'arlington-va' }

export const ATLANTA = { name: 'Atlanta', url: 'atlanta-ga' }

export const AUSTIN = { name: 'Austin', url: 'austin-tx' }

export const BALTIMORE = { name: 'Baltimore', url: 'baltimore-md' }

export const BOSTON = { name: 'Boston', url: 'boston-ma' }

export const CHARLOTTE = { name: 'Charlotte', url: 'charlotte-nc' }

export const CHICAGO = { name: 'Chicago', url: 'chicago-il' }

export const COLORADO_SPRINGS = { name: 'Colorado Springs', url: 'colorado-springs-co' }

export const DALLAS = { name: 'Dallas', url: 'dallas-tx' }

export const DENVER = { name: 'Denver', url: 'denver-co' }

export const DETROIT = { name: 'Detroit', url: 'detroit-mi' }

export const FORT_WORTH = { name: 'Fort Worth', url: 'fort-worth-tx' }

export const HOUSTON = { name: 'Houston', url: 'houston-tx' }

export const INDIANAPOLIS = { name: 'Indianapolis', url: 'indianapolis-in' }

export const KANSAS_CITY = { name: 'Kansas City', url: 'kansas-city-mo' }

export const LAS_VEGAS = { name: 'Las Vegas', url: 'las-vegas-nv' }

export const LOS_ANGELES = { name: 'Los Angeles', url: 'los-angeles-ca' }

export const MEMPHIS = { name: 'Memphis', url: 'memphis-tn' }

export const MIAMI = { name: 'Miami', url: 'miami-fl' }

export const MINNEAPOLIS = { name: 'Minneapolis', url: 'minneapolis-mn' }

export const NASHVILLE = { name: 'Nashville', url: 'nashville-tn' }

export const NEW_YORK = { name: 'New York', url: 'new-york-ny' }

export const OAKLAND = { name: 'Oakland', url: 'oakland-ca' }

export const ORLANDO = { name: 'Orlando', url: 'orlando-fl' }

export const PHILADELPHIA = { name: 'Philadelphia', url: 'philadelphia-pa' }

export const PHOENIX = { name: 'Phoenix', url: 'phoenix-az' }

export const PITTSBURGH = { name: 'Pittsburgh', url: 'pittsburgh-pa' }

export const PORTLAND = { name: 'Portland', url: 'portland-or' }

export const SACRAMENTO = { name: 'Sacramento', url: 'sacramento-ca' }

export const SAN_ANTONIO = { name: 'San Antonio', url: 'san-antonio-tx' }

export const SAN_DIEGO = { name: 'San Diego', url: 'san-diego-ca' }

export const SAN_FRANCISCO = { name: 'San Francisco', url: 'san-francisco-ca' }

export const SAN_JOSE = { name: 'San Jose', url: 'san-jose-ca' }

export const SEATTLE = { name: 'Seattle', url: 'seattle-wa' }

export const TAMPA = { name: 'Tampa', url: 'tampa-fl' }

export const WASHINGTON_DC = { name: 'Washington DC', url: 'washington-dc' }

// CA CITIES
export const CALGARY = { name: 'Calgary', url: 'calgary-ab' }

export const EDMONTON = { name: 'Edmonton', url: 'edmonton-ab' }

export const MONTREAL = { name: 'Montreal', url: 'montreal-qc' }

export const OTTAWA = { name: 'Ottawa', url: 'ottawa-on' }

export const QUEBEC_CITY = { name: 'Quebec City', url: 'quebec-qc' }

export const TORONTO = { name: 'Toronto', url: 'toronto-on' }

export const VANCOUVER = { name: 'Vancouver', url: 'vancouver-bc' }

export const WINNIPEG = { name: 'Winnipeg', url: 'winnipeg-mb' }
